import styled from 'styled-components';
import colors from '../utils/colors';

export const Block = styled.div`
  margin: 0 auto;
  max-width: 650px;
  padding-top: 2em;
  padding: 1em;
  text-align: left;
`;
export const Center = styled.div`
  margin: 0 auto;
  max-width: 650px;
  padding-top: 2em;
  padding: 1em;
  text-align: left;
  @media (max-width: 768px) {
    text-align: center;
  }
`;
export const Full = styled.div`
  margin: 0 auto;
  padding-top: 2em;
  padding: 1em 0 1em 0;
  position: relative;
`;

export const Dropcap = styled.span`
  font-weight: 300;
  float: left;
  font-size: 84px;
  line-height: 76px;
  margin: 0 7px -9px 0;
  font-weight: 100;
  color: ${colors.main};
  @media (min-width: 768px) {
    font-size: 95px;
    line-height: 82px;
    margin: 0 7px -12px 0;
  }
`;
export const DropcapSmall = styled.span`
  font-weight: 300;
  float: left;
  font-size: 57px;
  line-height: 56px;
  margin: 0 7px -9px 0;
  font-weight: 100;
  color: ${colors.main};
  @media (min-width: 768px) {
    font-size: 60px;
    line-height: 60px;
    margin: 0 7px -8px 0;
  }
`;
export const DropcapNext = styled.span`
  text-transform: uppercase;
  font-size: 100%;
  letter-spacing: 1.5px;
  padding-right: 1px;
  font-weight: 400;
  font-size: 15px;
`;



// WEBPACK FOOTER //
// ./src/styles/estilos.js